<template>
  <div class="headContent">
    <div class="header">
      <router-link to="/">
        <img style=" display: inline-block; width: 158px;margin-top:4px;" class="img" src="~@/assets/img/logo.png"
          alt='无感归集平台' />
      </router-link>
      <div class="center">
        <div class="everyPart" @mouseout="(item.show = false)" @mouseover="showService(item)"
          v-for="(item, index) in headerData" :key="index">
          <div v-if="item.openUrl" class="urlSty" @click="openUrl(item.openUrl)">
            {{ item.word }}
          </div>
          <router-link v-else :to="item.url"> {{ item.word }}</router-link>
          <!-- <div v-show='item.show'  style="position:absolute;z-index:100;width:100%;width:165px;color:#084471;top:74px">
            <div   class="service" v-for="(val,i) in secondData" :class="{active:i==current}"  style="border:1px solid #A5B2CB;height:54px;line-height:54px;" :key='i'>
                <div class="hover" @click="closeService(val,item)"> {{val.select}}  </div>
            </div>
          </div> -->
        </div>
      </div>
      <div style="width:130px;line-height:70px;position:relative;">
        <a style="text-decoration: none; color: black; " href="https://ipdcloud.wch.cn/manage/login#/login"
          target="_blank">请登录
          <img style="width:50px;height:50px;display: inline-block;position: absolute;top:10px;right:0"
            src="~@/assets/img/btn.png" alt /></a>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
export default {
  props: {
    headImgShow: {
      type: Boolean,
      default: true
    },
    current: {
      default: 0
    }
  },
  data() {
    return {
      headerData: [
        { word: "首  页", url: "/", show: false },
        { word: "产品与服务", url: "/service", show: false },
        { word: "帮助中心", url: "/help", show: false },
        { word: "关于我们", url: "/aboutUs", show: false, openUrl: 'https://wch.cn/about_us.html' }
      ],
      // currentHead:0
    };
  },
  methods: {
    showService(item) {
      if (item.word == '产品与服务') {
        item.show = true
      }
    },
    openUrl(url) {
      // 参数：地址，窗口名，窗口配置
      window.open(url, '_blank')
    }
    // closeService(val,item){
    //   if(val.select=='数联云盒'){
    //     this.$router.push({path:'/service'})
    //     this.current=0
    //   }else{
    //     this.$router.push({path:'/service/sys'})
    //     this.current=1
    //   }
    //   item.show=false
    // }
  }
};
</script>
<style scoped lang='scss'>
.everyPart>a {
  text-decoration: none;
  color: black;
  width: 165px;
  height: 70px;
  line-height: 70px;
  display: inline-block;
  border-bottom: 4px solid transparent;
}

.urlSty {
  text-decoration: none;
  color: black;
  width: 165px;
  height: 70px;
  line-height: 70px;
  display: inline-block;
  border-bottom: 4px solid transparent;
  cursor: pointer;
}

.center {
  display: flex;
  justify-content: space-between;

}

// 
.center {
  .router-link-exact-active {
    text-decoration: none;
    width: 165px;
    height: 100%;
    color: #004b8f;
    border-bottom: 4px solid #004b8f;
  }
}

.header {
  display: flex;
  height: 70px;
  justify-content: space-between;
  width: 1200px;
  margin: 0 auto;
}

.active {
  color: white;
  background: #99B8D2
}

.hover {
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/header.vue